// Todo File integration
import constants from '@/constants';
/**
 * Registration Component
 * @param {Ref} component Component instance
 * @param {String} compName Component name
 * @returns {ref} component
 */
export const withInstall = (component, compName) => {
  component.install = app => {
    if (!compName) return;
    app.component(compName, component);
  };
  return component;
};

// Process store name filtering spaces and Chinese characters
export const processBrandName = (brandName, reg = constants.TEXT_REG) => {
  if (!brandName) return;
  // eslint-disable-next-line consistent-return
  return brandName.replace(reg, '');
};

// Extract the distance between the upper and lower security zones of the app
export const extractAppDeivceScreen = userAgent => {
  const objScreen = {
    top: 0,
    bottom: 0
  };
  if (!userAgent?.appDeviceScreen) return objScreen;
  objScreen.top = userAgent.appDeviceScreen.split('_')[0];
  objScreen.bottom = userAgent.appDeviceScreen.split('_')[1];
  return objScreen;
};
